<template>
  <div id="info">
    <van-nav-bar
      title="证件信息"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      style="margin-bottom: 20px;"
    />
    <van-form>
      <div style="text-align: left;padding-left: 20px;">健康码</div>
      <div class="uploader">
        <van-field name="uploader" title="">
          <template #input>
            <van-uploader v-model="postForm.health_img"
                          :max-size="maxSize"
                          :before-read="beforeRead"
                          :after-read="file => onRead(file, 'health')"
                          :before-delete="file => deleteFile(file, 'health')"
                          :max-count="1"
                          @oversize="onOversize"/>
          </template>
        </van-field>
      </div>
      <div style="text-align: left;padding-left: 20px;">行动报告</div>
      <div class="uploader">
        <van-field name="uploader" title="">
          <template #input>
            <van-uploader v-model="postForm.travel_img"
                          :max-size="maxSize"
                          :before-read="beforeRead"
                          :after-read="file => onRead(file, 'travel')"
                          :before-delete="file => deleteFile(file, 'travel')"
                          :max-count="1"
                          @oversize="onOversize"/>
          </template>
        </van-field>
      </div>
      <div style="text-align: left;padding-left: 20px;">核酸检测图片</div>
      <div class="uploader">
        <van-field name="uploader" title="">
          <template #input>
            <van-uploader v-model="postForm.nucleic_img"
                          :max-size="maxSize"
                          :before-read="beforeRead"
                          :after-read="file => onRead(file, 'nucleic')"
                          :before-delete="deleteFile"
                          :max-count="1"
                          @oversize="onOversize"/>
          </template>
        </van-field>
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="onSubmit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {Toast} from 'vant'
import {getManInfo, updateManInfo} from '@/api/user'
import Uploader from './uploader'
import {getOssToken} from "../../../api/order";
import OSS from "ali-oss";
import {getFileRealPath} from "../../../api/util";

export default {
  name: 'info',
  components: {
    Uploader
  },
  data () {
    return {
      maxSize: 40960 * 1024,
      postForm: {
        health_img: [],
        travel_img: [],
        nucleic_img: []
      },
      imageList: [],
      activeNames: ['1'],
    }
  },
  created() {
    this.initUserInfo()
  },
  methods: {
    async initUserInfo() {
      await getManInfo().then((res) => {
        if (res.data.data) {
          const details = res.data.data && res.data.data.certificate_list
          if (details.health_report) {
            this.postForm.health_img = [
              {
                url: details.health_report.img_health_qrcode.file_url_thumb.replace('http:', 'https:'),
                status: ''
              }
            ]
            this.postForm.img_health_qrcode = details.health_report.img_health_qrcode.file_id
            this.postForm.travel_img = [
              {
                url: details.health_report.img_travel_qrcode.file_url_thumb.replace('http:', 'https:'),
                status: ''
              }
            ]
            this.postForm.img_travel_qrcode = details.health_report.img_health_qrcode.file_id
            this.postForm.nucleic_img = [{
              url: details.health_report.img_nucleic_acid_report.file_url_thumb.replace('http:', 'https:'),
              status: ''
            }]
            this.postForm.img_nucleic_acid_report = details.health_report.img_nucleic_acid_report.file_id
          }
          if (this.postForm.certificate_id) {
            this.postForm.certificate_id = details.health_report.certificate_id
          }
          console.log('postForm......', this.postForm)
          this.$forceUpdate()
        }
      })
    },
    onOversize() {

    },
    onClickLeft() {
      this.$router.push('/my')
    },
    beforeRead (file) {
      if (file.length > 1) {
        for (const i in file) {
          if (file[i].type !== 'image/jpeg' && file[i].type !== 'image/png' && file[i].type !== 'image/jpg') {
            Toast('请上传图片')
            return false
          }
        }
      } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
          Toast('请上传图片')
          return false
        }
      }
      return true
    },
    deleteFile(file, type) {
      if (type === 'health') {
        this.postForm.health_img = []
      }
      if (type === 'travel') {
        this.postForm.travel_img = []
      }
      if (type === 'nucleic') {
        this.postForm.nucleic_img = []
      }
    },
    onRead(file, index) {
      this.uploadImg(file.file, index)
    },
    async uploadImg(file, index) {
      let fileSuffix = ''
      if (file.type === 'image/jpeg') {
        fileSuffix = 'jpeg'
      }
      if (file.type === 'image/png') {
        fileSuffix = 'png'
      }
      if (file.type === 'image/jpg') {
        fileSuffix = 'jpg'
      }
      await getOssToken({ file_suffix: fileSuffix }).then((res) => {
        if (res.data.data) {
          const ossData = res.data.data
          const client = new OSS({
            region: 'oss-' + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          })
          client.put(ossData.file_name, file).then((result) => {
            if (result && result.url) {
              getFileRealPath({file_id: ossData.file_id}).then((res) => {
                if (res.data.data && res.data.data.file_url_original) {
                  if (index === 'health') {
                    this.postForm.img_health_qrcode = ossData.file_id
                    this.postForm.health_img = [{
                      url: res.data.data.file_url_original,
                      status: '',
                      id: ossData.file_id,
                      name: ossData.file_name
                    }]
                  }
                  if (index === 'travel') {
                    this.postForm.img_travel_qrcode = ossData.file_id
                    this.postForm.travel_img = [{
                      url: res.data.data.file_url_original,
                      status: '',
                      id: ossData.file_id,
                      name: ossData.file_name
                    }]
                  }
                  if (index === 'nucleic') {
                    this.postForm.img_nucleic_acid_report = ossData.file_id
                    this.postForm.nucleic_img = [{
                      url: res.data.data.file_url_original,
                      status: '',
                      id: ossData.file_id,
                      name: ossData.file_name
                    }]
                  }

                  this.$forceUpdate()
                }
              })

            }
          })
        }
      })
    },
    forwardLogin() {
      this.$router.push({path: '/'})
    },
    async onSubmit() {
      const electrician_certificate = {
        certificate_type: 'health_report',
        info:
          {
            img_health_qrcode: this.postForm.img_health_qrcode,
            img_travel_qrcode: this.postForm.img_travel_qrcode,
            img_nucleic_acid_report: this.postForm.img_nucleic_acid_report
          }
      }
      if (this.postForm.ele_certificate_id) {
        electrician_certificate.certificate_id = this.postForm.id_certificate_id
      }

      const updateEleResult = await updateManInfo(electrician_certificate)

      setTimeout(() => {
        Toast('提交成功')
        this.$router.push('/my')
      }, 2000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/components/health_report.vue